<template>
  <div role="order-card" class="lg:flex mb-8 lg:mb-6 last:mb-0">
    <div
      role="order-card__header"
      class="w-full lg:flex-[0_0_42%] lg:max-w-[42%] lg:pr-4 max-lg:mb-12"
    >
      <div class="ui-text-m text-primary mb-2">
        {{ $t("ordered") }}
        <span class="font-medium">
          {{ format(new Date(order.customer_date), "MMMM do, yyyy") }}
        </span>
      </div>
      <div>
        <nuxt-link
          class="ui-text-m text-primary underline underline-offset-2 hover:no-underline"
          :to="
            localePath({
              path: `/orders/${order.id}`,
              query: {
                email: route.query.email || undefined,
                number: route.query.number || undefined,
                billing_zip: route.query.billing_zip || undefined,
              },
            })
          "
        >
          {{ t("orderWithID", { id: order.po_number }) }}
        </nuxt-link>
      </div>
    </div>
    <div
      role="order-card__body"
      class="w-full lg:flex-[0_0_58%] lg:max-w-[58%]"
    >
      <ul class="grid grid-cols-2 md:grid-cols-4 gap-x-2">
        <template v-for="(product, index) in orderProductsData" :key="index">
          <li>
            <ProfileOrderHistoryProductCard :product="product" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate";
import { OrderData } from "ecom-types";
import { format } from "date-fns";

const route = useRoute();
const props = defineProps<{ order: OrderData }>();
const { t } = useI18n();
const localePath = useLocalePathPolyfill();
const { orderProductsData } = useReturn(props.order, useForm);
</script>
